import { render, staticRenderFns } from "./UserRecycleBinModal.vue?vue&type=template&id=69d3429e&scoped=true&"
import script from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"
export * from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d3429e",
  null
  
)

export default component.exports